import Point from "./classes/Point";
import { Vector } from "./classes/Vector";
import { getRandomInt } from "./utils";

export function createSnow(amount, minSize, maxSize) {
  const snow = Array(amount)
    .fill("")
    .map(() => ({
      point: new Point(
        Math.random() * window.innerWidth,
        Math.random() * window.innerHeight
      ),
      size: getRandomInt(minSize, maxSize),
      vector: new Vector(0, 0),
    }));

  return snow;
}
